import axios from 'axios';

export type CentralizedQueuePreferencesState = {
  isModified: boolean;
};

const getCentralizedQueuePreferencesState =
  async (): Promise<CentralizedQueuePreferencesState> => {
    const { data } = await axios.get<CentralizedQueuePreferencesState>(
      `/answering/queue_preferences/state`,
    );
    return data;
  };

export default getCentralizedQueuePreferencesState;
